// Типизированный API-клиент из FastAPI /openapi.json (openapi-fetch). Заменяет ручной api() (web/app-core.js).
// Порт семантики: база с обрезанным хвостовым "/", Bearer-токен, перехват 401 (кроме /api/auth/*).
// Политика «optional 401 не разлогинивает» (legacy opts.optional) — на уровне query-хуков Фазы 2.

import createClient, { type Client, type Middleware } from "openapi-fetch";
import type { paths } from "./schema";

export interface ApiClientOptions {
  /** База API (window.KQUANT_DEFAULT_API). Хвостовые "/" обрезаются — как в legacy. */
  baseUrl: string;
  /** Текущий JWT (localStorage kq_token в приложении). Пусто → без Authorization. */
  getToken: () => string;
  /** 401 на не-/api/auth/* → сессия протухла (сброс токена + экран входа). Получает путь запроса. */
  onUnauthorized?: (path: string) => void;
  /** Переопределение fetch (для тестов/SSR). По умолчанию — глобальный fetch. */
  fetch?: typeof globalThis.fetch;
}

export type KquantClient = Client<paths>;

export function createApiClient({ baseUrl, getToken, onUnauthorized, fetch }: ApiClientOptions): KquantClient {
  const client = createClient<paths>({
    baseUrl: baseUrl.replace(/\/+$/, ""),
    ...(fetch ? { fetch } : {}),
  });

  const auth: Middleware = {
    onRequest({ request }) {
      const t = getToken();
      if (t) request.headers.set("Authorization", `Bearer ${t}`);
      return request;
    },
    onResponse({ request, response }) {
      if (response.status === 401) {
        const path = new URL(request.url).pathname;
        if (!path.startsWith("/api/auth/")) onUnauthorized?.(path);
      }
      return response;
    },
  };
  client.use(auth);
  return client;
}
